export default {
  confirm: 'تأكيد',
  cancel: 'إلغاء',
  ok: 'حسنًا',
  back: 'رجوع',
  submit: 'إرسال',
  retry: 'إعادة المحاولة',
  delete: 'حذف',
  close: 'إغلاق',
  openInNewWindow: 'فتح في نافذة جديدة',
  codeNotReceived: 'لم يتم استلام الكود؟',
  forgotPassword: 'نسيت كلمة المرور؟',
  or: 'أو',
  disable: 'تعطيل',
  save: 'حفظ',
  login: 'تسجيل الدخول',
  logout: 'تسجيل الخروج',
  edit: 'تعديل',
  chooseLanguage: 'اختر اللغة',
  unknownError: 'حدث خطأ',
  waitBeforeRetry: 'الرجاء الانتظار {timeRemaining} قبل المحاولة مرة أخرى',
  yes: 'نعم',
  no: 'لا',
  dontAsk: 'لا تسأل مرة أخرى'
}
